import { BasketBook } from '../../types/book'

export const getBooksFromLocalBasket = (): BasketBook[] => {
  const bookIdsString = localStorage.getItem('basket')
  const basketBooks: BasketBook[] = bookIdsString
    ? JSON.parse(bookIdsString)
    : []
  return basketBooks
}
